const typeEducationInstitutesAvailables = [
  { label: 'Otros', keyword: 'otros', id: 1 },
  { label: 'Institutos', keyword: 'educacion-institutos', id: 2 },
  { label: 'Tecnológicos', keyword: 'educacion-tecnologicos', id: 3 },
  { label: 'Universidad', keyword: 'educacion-universitaria', id: 4 },
  { label: 'Colegios', keyword: 'educacion-colegios', id: 5 },
];

export default typeEducationInstitutesAvailables;
